// data.js
// ["all", "outerwear", "tops", "bottoms", "hats", "accessories"]
export const products = [
  {
    id: 1,
    name: "Niepce Inc Men's Japanese Streetwear Techwear Cargo Pants",
    image: "https://m.media-amazon.com/images/I/61iYJNq-CqL._AC_SX679_.jpg",
    category: "bottoms",
    // price: "$89.00",
    link: "https://amzn.to/4q8PhmA",
  },
  {
    id: 2,
    name: "Niepce Inc Japanese Streetwear Techwear Kanji Cargo Pants for Men",
    image: "https://m.media-amazon.com/images/I/71sBFVowLlL._AC_SX569_.jpg",
    category: "bottoms",
    // price: "$89.00",
    link: "https://amzn.to/49uSsiC",
  },
  {
    id: 3,
    name: "Niepce Inc Japanese Streetwear Zip Up Windbreaker Jackets for Men",
    image: "https://m.media-amazon.com/images/I/61bayuWMebL._AC_SX679_.jpg",
    category: "outerwear",
    // price: "$89.00",
    link: "https://amzn.to/3N765Mh",
  },
  {
    id: 4,
    name: "EKLENTSON Men's Military Windbreaker Jacket",
    image: "https://m.media-amazon.com/images/I/61tBOvfc9XL._AC_SX679_.jpg",
    category: "outerwear",
    // price: "$89.00",
    link: "https://amzn.to/49eMrp0",
  },
  {
    id: 5,
    name: "Teamlife Max Cool Mesh Back Hat",
    image: "https://m.media-amazon.com/images/I/61sxakr3hFL._AC_SX679_.jpg",
    category: "hats",
    // price: "$89.00",
    link: "https://amzn.to/4siZ1w7",
  },
  {
    id: 6,
    name: "Niepce Inc Japanese Techwear Embroidered Cap",
    image: "https://m.media-amazon.com/images/I/71Bjpgr6PrL._AC_SX569_.jpg",
    category: "hats",
    // price: "$89.00",
    link: "https://amzn.to/4jkQsgm",
  },
  {
    id: 7,
    name: "Punk Mask Helmet",
    image: "https://m.media-amazon.com/images/I/61HyWY5zg1L._AC_SX679_.jpg",
    category: "accessories",
    // price: "$89.00",
    link: "https://amzn.to/4qtrZaS",
  },
  {
    id: 8,
    name: "Niepce Inc Graphic Cyberpunk Hoodies",
    image: "https://m.media-amazon.com/images/I/61vCVdtqOvL._AC_SX679_.jpg",
    category: "outerwear",
    // price: "$89.00",
    link: "https://amzn.to/44HHgg4",
  },
  {
    id: 9,
    name: "DUDHUH Japanese Techwear Shirt",
    image: "https://m.media-amazon.com/images/I/51H83L0kwkL._AC_SX679_.jpg",
    category: "tops",
    // price: "$89.00",
    link: "https://amzn.to/4smt1Yc",
  },
  {
    id: 10,
    name: "Triangle Logo Techwear Cap - Fabric of the Universe",
    image: "https://m.media-amazon.com/images/I/71p1XxYx-KL._AC_SX569_.jpg",
    category: "hats",
    // price: "$89.00",
    link: "https://amzn.to/3YfS2GI",
  },
  {
    id: 11,
    name: "Cyberpunk Streetwear Fashion Sweater - Fabric of the Universe",
    image:
      "https://i.pinimg.com/736x/9d/4d/02/9d4d02dae7427938e8f6111fac453dee.jpg",
    category: "tops",
    // price: "$89.00",
    link: "https://amzn.to/4pexgC6",
  },
  {
    id: 12,
    name: "Niepce Inc Japanese Techwear Parka Jacket",
    image:
      "https://i.pinimg.com/736x/93/b6/ae/93b6aefad2ca84ec35e4faa559eed7e0.jpg",
    category: "tops",
    // price: "$89.00",
    link: "https://amzn.to/3N6mAIq",
  },
  {
    id: 13,
    name: "Cyberpunk LED Mask–Futuristic Techwear Helmet",
    image:
      "https://i.pinimg.com/736x/da/b3/c6/dab3c69d192663d4e7f7cb745442221b.jpg",
    category: "accessories",
    // price: "$89.00",
    link: "https://amzn.to/4q2EoTw",
  },
];

// ["all", "outerwear", "tops", "bottoms", "hats", "accessories"]
